import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import {
  toWidgetEditable
} from '@ckeditor/ckeditor5-widget/src/utils';

export default class FigCaptionTagEditing extends Plugin {
  init() {
    const editor = this.editor;
    const schema = editor.model.schema;
   
    schema.register( 'figcaptionTag', {
      allowWhere: ['$text'],
      allowContentOf: '$block',
      isObject: true,
      inheritAllFrom: 'paragraph',
      isLimit:true,
      allowAttributes: ['class']
    } );

    editor.conversion.for('upcast').elementToElement({
      view: {
        name: 'figcaption',
        classes: 'media-caption-class'
      },
      model: (viewElement, { writer: modelWriter }) => {
        return modelWriter.createElement('figcaptionTag', viewElement.getAttributes());
      }
    });

    editor.conversion.for('dataDowncast').elementToElement({
      model: 'figcaptionTag',
      view: {
        name: 'figcaption',
        classes: 'media-caption-class'
      }
    });

    editor.conversion.for( 'editingDowncast' ).elementToElement( {
      model: 'figcaptionTag',
      view: ( modelElement, { writer: viewWriter } ) => {
        const figcaption = viewWriter.createEditableElement( 'figcaption', { class: 'media-caption-class' , style: 'text-align: left'});
        return toWidgetEditable( figcaption, viewWriter );
      }
    } );
  }
}